<template>
  <div class="user-feedback-container">
    <h1>User Feedback - Coming Soon</h1>
  </div>
</template>

<script>
export default {
  name: 'UserFeedback'
}
</script>

<style scoped>
.user-feedback-container {
  padding: 20px;
}
</style>